import React from 'react';
import './PageStyles.css';

const DashboardOverview: React.FC = () => {
  const stats = [
    {
      title: 'Total Campaigns',
      value: '24',
      change: '+12%',
      trend: 'up',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M7 3l0 18l6-3 6 3V3z"></path>
          <path d="M12 8l-2 2 2 2 2-2z"></path>
        </svg>
      ),
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    {
      title: 'Active Users',
      value: '1,847',
      change: '+8%',
      trend: 'up',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      ),
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
    },
    {
      title: 'Engagement Rate',
      value: '68.4%',
      change: '+2.3%',
      trend: 'up',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"></polyline>
        </svg>
      ),
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
    },
    {
      title: 'Revenue',
      value: '$12,847',
      change: '-3.2%',
      trend: 'down',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L2 7v10c0 5.55 3.84 9.95 9 11 5.16-1.05 9-5.45 9-11V7l-10-5z"></path>
          <path d="M9 12l2 2 4-4"></path>
        </svg>
      ),
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
    }
  ];

  const recentActivity = [
    {
      action: 'New campaign created',
      description: 'Instagram Marketing Campaign launched',
      time: '2 hours ago',
      type: 'campaign',
      user: 'Sarah Chen',
      avatar: '🚀'
    },
    {
      action: 'User registered',
      description: 'john.doe@example.com joined the platform',
      time: '4 hours ago',
      type: 'user',
      user: 'System',
      avatar: '👋'
    },
    {
      action: 'Integration connected',
      description: 'LinkedIn API successfully connected',
      time: '6 hours ago',
      type: 'integration',
      user: 'Mike Johnson',
      avatar: '🔗'
    },
    {
      action: 'Report generated',
      description: 'Monthly analytics report created',
      time: '1 day ago',
      type: 'report',
      user: 'Analytics Bot',
      avatar: '📊'
    },
    {
      action: 'Campaign optimized',
      description: 'AI optimization improved CTR by 23%',
      time: '2 days ago',
      type: 'optimization',
      user: 'AI Assistant',
      avatar: '🎯'
    }
  ];

  const quickActions = [
    {
      title: 'Create Campaign',
      description: 'Launch a new marketing campaign',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 5v14m-7-7h14"></path>
        </svg>
      ),
      gradient: 'linear-gradient(135deg, #1DB584, #10B981)',
      primary: true
    },
    {
      title: 'View Analytics',
      description: 'Explore detailed insights',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"></polyline>
        </svg>
      ),
      gradient: 'linear-gradient(135deg, #667eea, #764ba2)'
    },
    {
      title: 'Connect Platform',
      description: 'Add new social media accounts',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
      gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)'
    },
    {
      title: 'AI Insights',
      description: 'Get smart recommendations',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"></path>
          <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"></path>
        </svg>
      ),
      gradient: 'linear-gradient(135deg, #fa709a, #fee140)'
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="header-welcome">
          <div className="welcome-time">
            <span className="time-indicator">🌅</span>
            Good morning, Demo User
          </div>
          <h1 className="page-title">Dashboard Overview</h1>
          <p className="page-subtitle">Here's what's happening with your network today</p>
        </div>
        
        <div className="header-actions">
          <button className="header-btn refresh">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23,4 23,10 17,10"></polyline>
              <polyline points="1,20 1,14 7,14"></polyline>
              <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>
            </svg>
            Refresh
          </button>
          <button className="header-btn export">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7,10 12,15 17,10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Export
          </button>
        </div>
      </div>

      {/* Enhanced Stats Grid */}
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card enhanced" style={{ '--stat-gradient': stat.gradient } as React.CSSProperties}>
            <div className="stat-background"></div>
            <div className="stat-icon" style={{ background: stat.gradient }}>
              {stat.icon}
            </div>
            <div className="stat-content">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-title">{stat.title}</div>
              <div className={`stat-change ${stat.trend}`}>
                <span className="change-indicator">
                  {stat.trend === 'up' ? 
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="23,6 13.5,15.5 8.5,10.5 1,18"></polyline>
                      <polyline points="17,6 23,6 23,12"></polyline>
                    </svg>
                    :
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="23,18 13.5,8.5 8.5,13.5 1,6"></polyline>
                      <polyline points="17,18 23,18 23,12"></polyline>
                    </svg>
                  }
                </span>
                {stat.change}
              </div>
            </div>
            <div className="stat-sparkline"></div>
          </div>
        ))}
      </div>

      {/* Content Grid */}
      <div className="content-grid">
        {/* Enhanced Chart Placeholder */}
        <div className="chart-container enhanced">
          <div className="section-header">
            <div className="section-title">
              <div className="section-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"></polyline>
                </svg>
              </div>
              <h3>Network Activity</h3>
            </div>
            <select className="time-filter enhanced">
              <option>Last 7 days</option>
              <option>Last 30 days</option>
              <option>Last 3 months</option>
            </select>
          </div>
          <div className="chart-placeholder enhanced">
            <div className="chart-mock">
              {[...Array(7)].map((_, i) => (
                <div 
                  key={i} 
                  className="chart-bar enhanced" 
                  style={{
                    height: `${Math.random() * 100 + 20}%`,
                    animationDelay: `${i * 0.1}s`
                  }}
                ></div>
              ))}
            </div>
            <div className="chart-insights">
              <div className="insight">
                <span className="insight-icon">📈</span>
                <span>+23% this week</span>
              </div>
              <div className="insight">
                <span className="insight-icon">🎯</span>
                <span>Best: Tuesday</span>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Recent Activity */}
        <div className="activity-container enhanced">
          <div className="section-header">
            <div className="section-title">
              <div className="section-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12,6 12,12 16,14"></polyline>
                </svg>
              </div>
              <h3>Recent Activity</h3>
            </div>
            <button className="view-all-btn enhanced">
              View All
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M7 17L17 7"></path>
                <path d="M7 7h10v10"></path>
              </svg>
            </button>
          </div>
          <div className="activity-list enhanced">
            {recentActivity.map((activity, index) => (
              <div key={index} className="activity-item enhanced">
                <div className="activity-avatar">
                  <span className="avatar-emoji">{activity.avatar}</span>
                </div>
                <div className="activity-content">
                  <div className="activity-header">
                    <div className="activity-action">{activity.action}</div>
                    <div className="activity-time">{activity.time}</div>
                  </div>
                  <div className="activity-description">{activity.description}</div>
                  <div className="activity-user">by {activity.user}</div>
                </div>
                <div className="activity-status">
                  <div className={`status-dot ${activity.type}`}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Enhanced Quick Actions */}
      <div className="quick-actions enhanced">
        <div className="section-header">
          <div className="section-title">
            <div className="section-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
              </svg>
            </div>
            <h3>Quick Actions</h3>
          </div>
        </div>
        <div className="actions-grid enhanced">
          {quickActions.map((action, index) => (
            <button 
              key={index} 
              className={`action-btn enhanced ${action.primary ? 'primary' : 'secondary'}`}
              style={{ '--action-gradient': action.gradient } as React.CSSProperties}
            >
              <div className="action-icon-wrapper">
                <span className="action-icon">{action.icon}</span>
              </div>
              <div className="action-content">
                <div className="action-title">{action.title}</div>
                <div className="action-description">{action.description}</div>
              </div>
              <div className="action-arrow">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M7 17L17 7"></path>
                  <path d="M7 7h10v10"></path>
                </svg>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardOverview; 